export default {
      id: "i-triangle-red-usage",
      viewBox: "0 0 14 14",
      url: __webpack_public_path__ + "img/sprite.svg#i-triangle-red",
      toString: function () {
        return this.url;
      }
    }